import React from 'react';
import {NavLink} from 'react-router-dom';

const MobileNav = () => {
return (
    <div className="mobile-navbar">
        <NavLink className="nav-link" to='home'>
            <div className="nav-btn">
                <i className="fa-solid fa-house fa-xl"></i>
            </div>
        </NavLink>
        <NavLink className="nav-link" to='requests'>
            <div className="nav-btn">
                <i className="fa-solid fa-clock fa-xl"></i>
            </div>
        </NavLink>
        <NavLink className="nav-link" to='inventory'>
            <div className="nav-btn">
                <i className="fa-solid fa-warehouse fa-xl"></i>
            </div>
        </NavLink>
        <NavLink className="nav-link" to='profile'>
            <div className="nav-btn">
                <i className="fa-solid fa-user fa-xl"></i>
            </div>
        </NavLink>
    </div>
)
}

export default MobileNav;